export class SpvAprovadoCheckList {
    constructor(
        public checkListId: number,
        public spvAprovadoId: number
    ) {}
}
